const SvgRevers60 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 60 60">
    <path fill="#373737" d="M12 31c.552 0 1-.672 1-1.5s-.448-1.5-1-1.5-1 .672-1 1.5.448 1.5 1 1.5" />
    <path fill="#373737" fillRule="evenodd" d="M7 5.78 18.099 8H28v44h-2V10h-2v41.82l-17 3.4V10H4v42H2V8h5zm2 2.44v44.56l13-2.6V10.82z" clipRule="evenodd" />
    <path fill="#373737" d="M32 8h26v44h-2V10H34v42h-2z" />
    <path fill="#373737" d="M49 29.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5.448-1.5 1-1.5 1 .672 1 1.5" />
    <path fill="#373737" fillRule="evenodd" d="M36 10.79V52.21l17-3.274V14.063zm2 39V13.21l13 2.504v31.57z" clipRule="evenodd" />
  </svg>;
export default SvgRevers60;